<template>
    <div >
<v-row no-gutters class="mt-16">
        <v-col  class="mt-16">
        </v-col>
        <v-col> 
        </v-col>
        </v-row>
<v-row no-gutters class="mt-16 text-center">
        <v-col cols="3" md="3" sm="4" xs="4" class="mt-16">
        </v-col>
        <v-col cols="6" md="6" sm="6" xs="6" class="pl-1">
            <svg class="pl" width="240" height="240" viewBox="0 0 240 240">
	<circle class="pl__ring pl__ring--a" cx="120" cy="120" r="105" fill="none" stroke="#000" stroke-width="20" stroke-dasharray="0 660" stroke-dashoffset="-330" stroke-linecap="round"></circle>
	<circle class="pl__ring pl__ring--b" cx="120" cy="120" r="35" fill="none" stroke="#000" stroke-width="20" stroke-dasharray="0 220" stroke-dashoffset="-110" stroke-linecap="round"></circle>
	<circle class="pl__ring pl__ring--c" cx="85" cy="120" r="70" fill="none" stroke="#000" stroke-width="20" stroke-dasharray="0 440" stroke-linecap="round"></circle>
	<circle class="pl__ring pl__ring--d" cx="155" cy="120" r="70" fill="none" stroke="#000" stroke-width="20" stroke-dasharray="0 440" stroke-linecap="round"></circle>
</svg>
        
</v-col>
</v-row>
<v-row no-gutters class="mt-16">
        <v-col cols="1" md="5" sm="1" xs="1" class="mt-16">
        </v-col>
        <v-col cols="10" md="6" sm="10" xs="10">
            <!-- <span style="font-size: 20px; font-weight: 500">
                {{ $t("message.resources") }}  . . . 
            </span> -->
        </v-col>
        </v-row>
        <v-row no-gutters>
        <v-col cols="1" md="5" sm="1" xs="1">
        </v-col>
        <v-col cols="10" md="6" sm="10" xs="10" class="pl-16">
            <!-- <span style="font-family: Sarabun; font-size: 40px; font-weight: 500">
              ( 00 : 00 :{{ value }})
            </span> -->
        </v-col>
        </v-row>
</div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      interval: {},
        value: 2,
        value1: 2,
        sharetoken: '',
      jwt: require('jsonwebtoken'),
    }
  },
  mounted() {
    this.uuid = this.$route.query.uuid
    localStorage.clear()
    this.sharetoken = this.$route.query.sharetoken || localStorage.getItem('share-token') || this.$route.query.shared_token
    // this.$swal('this.sharetoken4=', this.sharetoken , 'warning')
    // console.log('this.sharetoken', this.sharetoken)
    if(this.sharetoken === '' || this.sharetoken === undefined || this.sharetoken === null){
        if (localStorage.getItem("user-token") === null) {
            this.intervalvalu1()
        } else {
            this.$router.push({ path: '/manage' }).catch(() => {})
        }
    } else {
      this.sharetokenoneplatform()
    }
  },
  methods: {
    getloadding(){
    clearInterval(this.interval)
      this.$router.push({ path: '/manage' }).catch(() => {})
    //   window.location.href = "/"
      // console.log('getloadding')
    },
    decodejwttoken(data) {
      var token = data
      const decryptedText = this.CryptoJS.AES.decrypt(
        token,
        process.env.VUE_APP_SECRET_KEY
      )
        .toString(this.CryptoJS.enc.Utf8)
        .replace(/"/g, '')
      var data = this.jwt.decode(decryptedText)
      // var userData = data
      this.createthem(data.user._id)
    },
    sharetokenoneplatform () {
      this.axios.post(process.env.VUE_APP_API + "/api/lv1/auth/oneplatform/sharetoken", {
          sharetoken: this.sharetoken
          }).then(res => {
            // this.intervalvalu()
            // console.log('res', res.data.data)
            localStorage.setItem("share-token", this.sharetoken);
            localStorage.setItem("user-token", res.data.data.token);
            localStorage.setItem("access-token", res.data.data.oneid.access_token);
            localStorage.setItem( "refresh_token",  res.data.data.oneid.refresh_token );
            localStorage.setItem("oneid-token", res.data.data.oneid);
          this.decodejwttoken(res.data.data.token)
          }).catch(err => {
            console.log('err', err)
          })
    },
    createthem(userid) {
      this.loadingApiLogin = false;
          this.Disabled = false;
                // this.checkrole()
          if (this.$route.query.uuid === undefined || this.$route.query.uuid === '' || this.$route.query.uuid === null) {
                    // this.goPage("/activate");
          this.intervalvalu()
                    // this.goPage("/manage");
          } else {
                    // this.goPage('/join/?uuid=' + this.uuid )
          this.$router.push({ path: '/join/?uuid=' + this.uuid }).catch(() => {})
       }
      // this.axios
      //     .post(process.env.VUE_APP_API + "/api/v1/theme/create/", {
      //       user_id: userid
      // }).then(res => {
      //   if( res.data.result === 'Created' || res.data.result === 'Success'){
      //     this.loadingApiLogin = false;
      //     this.Disabled = false;
      //           // this.checkrole()
      //           if (this.$route.query.uuid === undefined) {
      //               // this.goPage("/activate");
      //               this.intervalvalu()
      //               // this.goPage("/manage");
      //             } else {
      //               // this.goPage('/join/?uuid=' + this.uuid )
      //               this.$router.push({ path: '/join/?uuid=' + this.uuid }).catch(() => {})
      //             }
      //           // console.log('Success', res.data)
      //   }
      // }).catch(err => {
      //   console.log('createidprofile', err.message)
      // })
    },
    intervalvalu() {
    const vm = this
    this.interval = setInterval(() => {
        if (this.value === 0) {
          // return (this.value = 0)
          this.value = 2
          vm.getloadding()
        }
        this.value -= 1
      }, 1000)

    },
    intervalvalu1() {
    const vm = this
    this.interval = setInterval(() => {
        if (this.value1 === 0) {
          // return (this.value = 0)
          this.value1 = 2
          vm.backlogin()
        }
        this.value1 -= 1
      }, 1000)

    },
    backlogin(){
      this.$swal(this.$t("message.Sessiontimeout") , '' , 'warning').then(result => {
          localStorage.clear()
          localStorage.setItem("lang", "th")
          clearInterval(this.interval)
          this.$router.push({ path: '/' }).catch(() => {})
        })
    }
  }
}
</script>

<style scoped>
.pl {
  width: 6em;
  height: 6em;
}

.pl__ring {
  animation: ringA 2s linear infinite;
}

.pl__ring--a {
  stroke: #15ff00;
}

.pl__ring--b {
  animation-name: ringB;
  stroke: #00f6a4;
}

.pl__ring--c {
  animation-name: ringC;
  stroke: #255ff4;
}

.pl__ring--d {
  animation-name: ringD;
  stroke: #00d9ff;
}

/* Animations */
@keyframes ringA {
  from, 4% {
    stroke-dasharray: 0 660;
    stroke-width: 20;
    stroke-dashoffset: -330;
  }

  12% {
    stroke-dasharray: 60 600;
    stroke-width: 30;
    stroke-dashoffset: -335;
  }

  32% {
    stroke-dasharray: 60 600;
    stroke-width: 30;
    stroke-dashoffset: -595;
  }

  40%, 54% {
    stroke-dasharray: 0 660;
    stroke-width: 20;
    stroke-dashoffset: -660;
  }

  62% {
    stroke-dasharray: 60 600;
    stroke-width: 30;
    stroke-dashoffset: -665;
  }

  82% {
    stroke-dasharray: 60 600;
    stroke-width: 30;
    stroke-dashoffset: -925;
  }

  90%, to {
    stroke-dasharray: 0 660;
    stroke-width: 20;
    stroke-dashoffset: -990;
  }
}

@keyframes ringB {
  from, 12% {
    stroke-dasharray: 0 220;
    stroke-width: 20;
    stroke-dashoffset: -110;
  }

  20% {
    stroke-dasharray: 20 200;
    stroke-width: 30;
    stroke-dashoffset: -115;
  }

  40% {
    stroke-dasharray: 20 200;
    stroke-width: 30;
    stroke-dashoffset: -195;
  }

  48%, 62% {
    stroke-dasharray: 0 220;
    stroke-width: 20;
    stroke-dashoffset: -220;
  }

  70% {
    stroke-dasharray: 20 200;
    stroke-width: 30;
    stroke-dashoffset: -225;
  }

  90% {
    stroke-dasharray: 20 200;
    stroke-width: 30;
    stroke-dashoffset: -305;
  }

  98%, to {
    stroke-dasharray: 0 220;
    stroke-width: 20;
    stroke-dashoffset: -330;
  }
}

@keyframes ringC {
  from {
    stroke-dasharray: 0 440;
    stroke-width: 20;
    stroke-dashoffset: 0;
  }

  8% {
    stroke-dasharray: 40 400;
    stroke-width: 30;
    stroke-dashoffset: -5;
  }

  28% {
    stroke-dasharray: 40 400;
    stroke-width: 30;
    stroke-dashoffset: -175;
  }

  36%, 58% {
    stroke-dasharray: 0 440;
    stroke-width: 20;
    stroke-dashoffset: -220;
  }

  66% {
    stroke-dasharray: 40 400;
    stroke-width: 30;
    stroke-dashoffset: -225;
  }

  86% {
    stroke-dasharray: 40 400;
    stroke-width: 30;
    stroke-dashoffset: -395;
  }

  94%, to {
    stroke-dasharray: 0 440;
    stroke-width: 20;
    stroke-dashoffset: -440;
  }
}

@keyframes ringD {
  from, 8% {
    stroke-dasharray: 0 440;
    stroke-width: 20;
    stroke-dashoffset: 0;
  }

  16% {
    stroke-dasharray: 40 400;
    stroke-width: 30;
    stroke-dashoffset: -5;
  }

  36% {
    stroke-dasharray: 40 400;
    stroke-width: 30;
    stroke-dashoffset: -175;
  }

  44%, 50% {
    stroke-dasharray: 0 440;
    stroke-width: 20;
    stroke-dashoffset: -220;
  }

  58% {
    stroke-dasharray: 40 400;
    stroke-width: 30;
    stroke-dashoffset: -225;
  }

  78% {
    stroke-dasharray: 40 400;
    stroke-width: 30;
    stroke-dashoffset: -395;
  }

  86%, to {
    stroke-dasharray: 0 440;
    stroke-width: 20;
    stroke-dashoffset: -440;
  }
}
</style>